export default {
      id: "business-book-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#business-book-usage",
      toString: function () {
        return this.url;
      }
    }